module.exports = __webpack_public_path__ + "img/cloud.e3ea7959.png";